/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box,
  Flex,
  Space,
  Switch,
  Text,
  useColorMode,
  useColorStyle,
} from '@tonic-one/react';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CSpinner from 'src/components/CSpinner';

import { GlobalApi } from '@Apis';
import ErrorAlert from '../../../components/Common/ErrorAlert';
import { useUtcOffsetStore } from '@Models/useUtcOffsetModel';
import { getUtcTime } from '@Utils/time';
import { usePermissionStore } from '@Models/usePermissionModel';
import { PermissionNameEnum } from '@Types/permissions';

const SuspiciousObjectSettings = () => {
  const { widthEditablePermission } = usePermissionStore();
  const withEditPermission = widthEditablePermission(
    PermissionNameEnum.administrator
  );
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  const [loading, setLoading] = useState<boolean>(false);
  const [errorMsg, setErrorMsg] = useState<string | undefined>(undefined);
  const { t } = useTranslation();
  const [enabledStatus, setEnabledStatus] = useState<boolean>(false);
  const [timeStamp, setTimeStamp] = useState<string>('');
  const offsetModel = useUtcOffsetStore();

  async function switchStatus(enabledStatus: boolean) {
    try {
      setLoading(true);
      const res =
        await GlobalApi.updateSuspiciousObjectSettingsEnabledStatus(
          enabledStatus
        );
      if (res.data) {
        setEnabledStatus(enabledStatus);
      } else {
        setErrorMsg(t('common.apiException.internalError'));
      }
    } catch (error) {
      setErrorMsg(t('common.apiException.internalError'));
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    (async function doCall() {
      try {
        setLoading(true);
        const status: { enabledStatus: boolean; lastUpdatedTime: string } = (
          await GlobalApi.getSuspiciousObjectSettingsEnabledStatus()
        ).data;
        setEnabledStatus(status.enabledStatus);
        setTimeStamp(status.lastUpdatedTime);
      } catch (err) {
        setErrorMsg(t('common.apiException.internalError'));
      } finally {
        setLoading(false);
      }
    })();
  }, []);
  return (
    <Box px="4x">
      {loading && <CSpinner />}
      <Box>
        {errorMsg && (
          <ErrorAlert
            errorMsg={errorMsg}
            onClose={() => setErrorMsg(undefined)}
          />
        )}
        <Flex m="16px 0px">
          <Text fontSize="lg" lineHeight="lg" color={colorStyle.color.primary}>
            {t('globalSetting.suspiciousObjectSetting.title')}
          </Text>
        </Flex>
        <Flex m="16px 0px">
          <Text
            color={colorStyle.color.secondary}
            lineHeight="lg"
            maxWidth={1000}
          >
            {t('globalSetting.suspiciousObjectSetting.description.content')}
          </Text>
        </Flex>
        <Flex m="16px 0px">
          <Text
            color={colorStyle.color.secondary}
            lineHeight="lg"
            maxWidth={1000}
          >
            {t('globalSetting.suspiciousObjectSetting.description.note')}
          </Text>
        </Flex>
        <Flex m="16px 0px">
          <Text>
            <Space>{t('globalSetting.note.title')}</Space>
            <Space width="1x"></Space>
            <Space color={colorStyle.color.secondary}>
              {t('globalSetting.note.applyToAllOrganizations')}
            </Space>
          </Text>
        </Flex>

        <Flex alignItems="center">
          <Switch
            disabled={!withEditPermission}
            pr="1x"
            id="approvedHeaderFields"
            checked={enabledStatus}
            onChange={async (e: any) => {
              await switchStatus(e.target.checked);
            }}
          />
          <Text>{t('globalSetting.suspiciousObjectSetting.title')}</Text>
        </Flex>
        {timeStamp && (
          <Flex ml="58px" mt="8px">
            <Text>
              {t('globalSetting.suspiciousObjectSetting.lastUpdateTime')}
              <Space width="1x" />
              {getUtcTime(
                timeStamp,
                offsetModel.offset,
                t('common.momentDateFormat')
              )}
            </Text>
          </Flex>
        )}
      </Box>
    </Box>
  );
};
export default SuspiciousObjectSettings;
